/** The input of "New from message type" (NewJobFromMessageTypeButton). */
export interface FromMessageTypeInput {
  messageType?: string;
  endpoint?: string;
  name?: string;
  integrationConnectionId?: string;
  defaultOrgUnitId?: string | null;
  acceptTestFlag?: boolean;
}

export interface DeclaredMessageType {
  name: string;
  endpoint: string;
}

/**
 * The input after an edit: picking a message type fills in its endpoint, unless the tenant has
 * already typed one of its own (anything but empty or the previous type's endpoint).
 */
export function withDeclaredEndpoint(
  previous: FromMessageTypeInput,
  next: FromMessageTypeInput,
  types: DeclaredMessageType[],
): FromMessageTypeInput {
  if (next.messageType === previous.messageType) return next;
  const previousEndpoint = types.find((t) => t.name === previous.messageType)?.endpoint;
  const untouched = !next.endpoint || next.endpoint === previousEndpoint;
  const declared = types.find((t) => t.name === next.messageType)?.endpoint;
  return untouched ? { ...next, endpoint: declared } : next;
}
